const AttributeEndpoints = {
  GET_ATTRIBUTES: (workspaceId: string, detail = false) => `/attributes/?workspace_id=${workspaceId}&detail=${detail}`,
  BULK_UPSERT: "/attributes/bulk_upsert/",
};

export default AttributeEndpoints;
